



































import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop, Watch} from 'vue-property-decorator';
import {ReplyModel} from '@/models/reply.model';
import {getToolbarConfig} from '@/utils/utils';
import {EditorToolbar, VueEditor} from 'vue2-editor';
import {
  acceptedModule, acceptedState,
  authModule,
  forumRepliesModule,
  forumRepliesState, userModule,
  userState
} from '@/utils/store-acessor';
import {TopicEvents} from '@/models/topic.model';
import {noop} from 'rxjs';
import {UserModel} from '@/models/user.model';
import {ChallengeModel} from '@/models/challenge.model';

@Component({
  components: {
    VueEditor
  }
})
export default class ChallengeTopicMessageForm extends Vue {
  @Prop({required: true}) challengerId!: number;
  @Prop({required: true}) topicId!: number;
  @Prop({required: false}) replyToUpdate!: ReplyModel;
  @Prop({required: false}) showEdit!: boolean;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @userModule.Getter('user') currentUser!: UserModel;
  @acceptedModule.Getter('acceptedChallenges') acceptedChallenges!: ChallengeModel[];
  @forumRepliesModule.Getter('loading') sending!: boolean;
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;

  customToolbar: EditorToolbar[] = getToolbarConfig();
  reply = new ReplyModel();

  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = '';

  @Watch('replyToUpdate')
  onReplyChange(newValue: ReplyModel) {
    if (newValue.message) {
      this.reply = {...newValue}
    }
  }

  async mounted() {
    this.reply = {...this.replyToUpdate};

    try {
      if (this.isAuthenticated && userState.contestant) {
        await acceptedState.fetchAcceptedChallenges({
          params: {page: 1}
        });
      }
    } catch (e) {
      noop()
    }
  }

  onSubmit() {
    this.snackbarVisibility = false;

    if (!this.reply.message) {
      return this.snackbarVisibility = true;
    }

    forumRepliesState.updateLoading(true);
    if (this.reply.id) {
      forumRepliesState.updateReply({
        reply: this.reply,
        topicId: this.topicId,
        challengerId: this.challengerId
      })
    } else {
      forumRepliesState.sendReply({
        challengerId: this.challengerId,
        topicId: this.topicId,
        reply: this.reply
      });
    }
    this.reply = new ReplyModel();
    this.messageFormClosed();
  }

  @Emit()
  onForumBack(): TopicEvents {
    return {showTable: true};
  }

  @Emit()
  messageFormClosed() {
    return;
  }

  @Emit()
  showEditForm() {
    return;
  }
}
